import React, { useState, useRef, useEffect } from "react";

import BcSepIcon from "../../asset/images/about/breadcrumb-separator.svg";

// Icons for advantages
import CheckIcon    from "../../asset/images/products/ador-tr-set/icon-check.svg";
import ShieldIcon   from "../../asset/images/products/ador-tr-set/icon-shield.svg";
import GearIcon     from "../../asset/images/products/ador-tr-set/icon-gear.svg";
import PowerIcon    from "../../asset/images/products/ador-tr-set/icon-power.svg";
import ChipIcon     from "../../asset/images/products/ador-tr-set/icon-chip.svg";
import FactoryIcon  from "../../asset/images/products/ador-tr-set/icon-factory.svg";
import LeafIcon     from "../../asset/images/products/ador-tr-set/icon-leaf.svg";

// Product cards images
import PhaseOneImg   from "../../asset/images/products/ador-tr-set/1-phase.webp";
import PhaseThreeImg from "../../asset/images/products/ador-tr-set/3-phase.webp";


const ADVANTAGES = [
  { icon: CheckIcon,  text: "Available in 1-phase, 3-phase, and 400 Hz configurations for tailored performance." },
  { icon: ShieldIcon, text: "Hermetically sealed construction with IP-65 protection ensures durability." },
  { icon: GearIcon,   text: "Easy maintenance with lid-mounted assembly." },
  { icon: PowerIcon,  text: "Ripple-free DC output and energy-efficient operation." },
  { icon: ChipIcon,   text: "Advanced microprocessor controls for precise performance." },
];

const END_APPLICATIONS = [
  { icon: FactoryIcon, text: "Industries: Cement, steel, power, chemicals, and paper." },
  { icon: LeafIcon,    text: "Ensures efficient dust collection and compliance with environmental standards." },
];

const PRODUCT_CARDS = [
  {
    img: PhaseOneImg,
    title: "1 Phase Solutions",
    desc: "The ESP power supplies were introduced in 1970s & ever since have a good field-proven performance...",
    link: "/products/esp-power-supplies/1-phase",
  },
  {
    img: PhaseThreeImg,
    title: "3 Phase Solutions",
    desc: "They consist primarily of a Thyristor controlled power-circuit, wherein the firing of the Thyristor is controlled to provide...",
    link: "/products/esp-power-supplies/3-phase",
  },
];

const FAQS = [
  {
    q: "Why are Ador TR Sets ideal for my ESP systems?",
    a: "Ador TR Sets feature advanced technologies like ripple-free DC output and energy-efficient operation. These ensure superior dust collection, reduced energy costs, and reliable performance even in demanding industrial environments.",
  },
  {
    q: "How do Ador TR Sets support environmental compliance?",
    a: "Engineered for maximum particulate collection efficiency, Ador TR Sets help industries like cement, steel, power, and chemicals meet stringent environmental regulations with ease.",
  },
  {
    q: "What makes Ador TR Sets durable and reliable?",
    a: "With hermetically sealed construction, IP-65-rated protection, and high-quality components, Ador TR Sets deliver long-term reliability and require minimal maintenance.",
  },
  {
    q: "Can Ador TR Sets be customized for specific requirements?",
    a: "Yes, Ador TR Sets are available in 1-phase, 3-phase, and 400 Hz configurations, allowing tailored solutions to meet your unique ESP performance needs.",
  },
  {
    q: "How can Ador TR Sets improve operational efficiency?",
    a: "Their energy-efficient design, easy maintenance features, and advanced microprocessor controls enhance performance, minimize downtime, and reduce overall operational costs, supporting sustainable and profitable operations.",
  },
];

const CSS = `
  @import url('https://fonts.googleapis.com/css2?family=Poppins:wght@300;400;500;600;700;800&display=swap');

  *, *::before, *::after { box-sizing: border-box; margin: 0; padding: 0; }
  .atrs-wrap { font-family: 'Poppins', sans-serif; color: #202020; background: #fff; }

  /* ══════════════════════════════════════════
     1. BREADCRUMB
  ══════════════════════════════════════════ */
  .atrs-breadcrumb { padding: 60px 0 0 0; }
  .atrs-breadcrumb-inner {
    max-width: 1600px;
    margin: 0 auto;
    padding: 0 102px;
    display: flex;
    align-items: center;
    flex-wrap: wrap;
    gap: 8px;
  }
  .atrs-bc-item {
    font-size: 16px;
    font-weight: 500;
    color: #202020;
    text-decoration: none;
    transition: color 0.15s;
  }
  .atrs-bc-item:hover { color: #EB2019; }
  .atrs-bc-item.atrs-active { color: #202020; }
  .atrs-bc-sep {
    display: flex;
    align-items: center;
    justify-content: center;
    width: 24px;
    height: 24px;
    border-radius: 50%;
    margin: 0 8px;
    flex-shrink: 0;
  }

  /* ══════════════════════════════════════════
     SHARED INNER
  ══════════════════════════════════════════ */
  .atrs-inner {
    max-width: 1600px;
    margin: 0 auto;
    padding: 0 102px;
  }

  /* ══════════════════════════════════════════
     SHARED DIVIDER
  ══════════════════════════════════════════ */
  .atrs-divider {
    max-width: 1600px;
    margin: 0 auto;
    padding: 0 102px;
  }
  .atrs-divider hr {
    border: none;
    border-top: 1px solid #D4D4D4;
    margin-top:80px;
  }
    .atrs-divider1 {
    max-width: 1600px;
    margin: 0 auto;
    padding: 0 102px;
  }
  .atrs-divider1 hr {
    border: none;
    border-top: 1px solid #D4D4D4;
    margin-top:60px;
  }

  /* ══════════════════════════════════════════
     2. INTRO — title + 2 paragraphs, no image
  ══════════════════════════════════════════ */
  .atrs-intro {
    padding: 60px 0 0px 0;
  }
  .atrs-intro-title {
    font-size: 32px;
    font-weight: 600;
    color: #202020;
    line-height: 130%;
    margin-bottom: 14px;
  }
  .atrs-para {
    font-size: 16px;
    font-weight: 400;
    color: #202020;
    line-height: 160%;
  }
  .atrs-para + .atrs-para { margin-top: 14px; }

  /* ══════════════════════════════════════════
     3. ADVANTAGES & APPLICATIONS
  ══════════════════════════════════════════ */
  .atrs-adv-section {
    padding: 0px 0 0px 0;
  }
  .atrs-section-red-title {
    font-size: 32px;
    font-weight: 600;
    color: #EB2019;
    text-align: center;
    margin-top: 80px;
  }
  .atrs-sub-heading {
    font-size: 32px;
    font-weight: 600;
    color: #202020;
    text-align: center;
    margin-bottom: 34px;
    padding-top: 60px;
  }

  /* Icon cards grid */
  .atrs-icon-row {
    display: flex;
    justify-content: center;
    gap: 31px;
    margin-bottom: 60px;
  }
  .atrs-icon-row:last-child {
    display: flex;
    justify-content: center;
    gap: 31px;
    margin-bottom: 0px;
  }
  .atrs-icon-card {
    flex: 0 0 445px;
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 24px;
    text-align: center;
  }
  .atrs-icon-circle {
    width: 72px;
    height: 72px;
    border-radius: 50%;
    display: flex;
    align-items: center;
    justify-content: center;
    flex-shrink: 0;
  }
  .atrs-icon-circle img {
    width: 84px;
    height: 84px;
    display: block;
  }
  .atrs-icon-text {
    font-size: 20px;
    font-weight: 400;
    color: #202020;
    line-height: 160%;
  }

  /* ══════════════════════════════════════════
     4. END APPLICATIONS
  ══════════════════════════════════════════ */
  .atrs-app-section {
    padding: 0 0 0px 0;
  }
  .atrs-contact-para {
    font-size: 20px;
    font-weight: 500;
    color: #202020;
    text-align: center;
    line-height: 160%;
    margin-top: 40px;
  }
  .atrs-contact-para a {
    color: #EB2019;
    font-weight: 500;
    text-decoration: none;
  }
  .atrs-contact-para a:hover { text-decoration: underline; }

  /* ══════════════════════════════════════════
     5. PRODUCT CARDS
  ══════════════════════════════════════════ */
  .atrs-cards-section {
    padding: 80px 0 0px 0;
  }
  .atrs-cards-grid {
    display: flex;
    gap: 64px;
    justify-content:center;
  }
  .atrs-card {
    flex: 1;
    border-radius: 10px;
    overflow: hidden;
    box-shadow: 0px 0px 20px rgba(0, 0, 0, 0.10);
    display: flex;
    flex-direction: column;
    max-width:445px;
    
  }
  .atrs-card-img {
    width: 100%;
    height: 300px;
    object-fit: cover;
    display: block;
  }
  .atrs-card-body {
    padding: 24px 24px 24px 24px;
    display: flex;
    flex-direction: column;
    gap: 14px;
    flex: 1;
  }
  .atrs-card-title {
    font-size: 20px;
    font-weight: 600;
    color: #202020;
    line-height: 140%;

  }
  .atrs-card-desc {
    font-size: 16px;
    font-weight: 400;
    color: #202020;
    line-height: 140%;
  }
  .atrs-card-link {
    display: inline-flex;
    align-items: center;
    gap: 14px;
    font-size: 16px;
    font-weight: 500;
    color: #EB2019;
    text-decoration: none;
    margin-top: auto;
  }
  .atrs-card-link:hover { text-decoration: underline; }
  .atrs-card-link svg {
    width: 18px;
    height: 18px;
    flex-shrink: 0;
  }

  /* ══════════════════════════════════════════
     6. FAQ SECTION
  ══════════════════════════════════════════ */
  .atrs-faq-section {
    padding: 120px 0 120px 0;
  }
  .atrs-faq-grid {
    display: flex;
    gap: 154px;
    align-items: flex-start;
  }
  .atrs-faq-title {
    flex: 0 0 391px;
    font-size: 42px;
    font-weight: 600;
    color: #202020;
    line-height: 140%;
  }
  .atrs-faq-list {
    flex: 1;
    display: flex;
    flex-direction: column;
    gap: 20px;
  }

  /* FAQ item wrapper */
  .atrs-faq-item {
    border-radius: 5px;
    overflow: hidden;
  }
  .atrs-faq-item-closed { background: #F6F6F6; }
  .atrs-faq-item-open   { background: #F6F6F6; }

  /* Question button */
  .atrs-faq-question {
    width: 100%;
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: 16px;
    padding: 24px 34px 20px 30px;
    background: transparent;
    border: none;
    cursor: pointer;
    text-align: left;
  }
  .atrs-faq-q-text-open {
    font-size: 16px;
    font-weight: 500;
    color: #EB2019;
    line-height: 120%;
    flex: 1;
  }
  .atrs-faq-q-text-closed {
    font-size: 16px;
    font-weight: 400;
    color: #202020;
    line-height: 150%;
    flex: 1;
  }
  .atrs-faq-chevron {
    flex-shrink: 0;
    width: 20px;
    height: 20px;
    display: flex;
    align-items: center;
    justify-content: center;
  }

  /* ── Smooth accordion answer panel ── */
  .atrs-faq-body {
    overflow: hidden;
    transition: max-height 0.4s ease, opacity 0.4s ease;
    opacity: 0;
    max-height: 0;
  }
  .atrs-faq-body.atrs-faq-body-open { opacity: 1; }
  .atrs-faq-answer {
    padding: 0 48px 24px 30px;
    font-size: 14px;
    font-weight: 400;
    color: #202020;
    line-height: 160%;
  }

  /* ══════════════════════════════════════════
     RESPONSIVE — TABLET 768px
  ══════════════════════════════════════════ */
  @media (max-width: 768px) {
    .atrs-breadcrumb        { padding: 28px 0 0 0; }
    .atrs-breadcrumb-inner  { padding: 0 32px; }
    .atrs-inner             { padding: 0 32px; }
    .atrs-divider           { padding: 0 32px; }
      .atrs-divider1           { padding: 0 32px; }
      .atrs-divider1 hr { margin-top:40px;}
      .atrs-divider hr { margin-top:40px;}

    .atrs-intro             { padding: 40px 0 0px 0; }
    .atrs-intro-title       { font-size: 22px; }
    .atrs-para              { font-size: 14px; }

    .atrs-adv-section       { padding: 0px 0 0px 0; }
    .atrs-section-red-title { font-size: 22px;     margin-top: 40px;}
    .atrs-sub-heading       { font-size: 20px; margin-bottom: 30px; padding-top: 40px; }
    .atrs-icon-row          { flex-wrap: wrap; gap: 24px; margin-bottom: 30px; }
    .atrs-icon-card         { flex: 0 0 210px; }
    .atrs-icon-text         { font-size: 16px; }
    .atrs-icon-circle       { width: 54px; height: 54px; }
    .atrs-icon-circle img   { width: 60px; height: 60px; }

    .atrs-app-section       { padding: 0 0 0px 0; }
    .atrs-contact-para      { font-size: 16px; }

    .atrs-cards-section     { padding: 40px 0 0px 0; }
    .atrs-cards-grid        {  display:grid;gap: 24px; justify-content:center;  grid-template-columns: repeat(2, 1fr); }
    .atrs-card-img          { height: 220px; width:100%; }

    .atrs-faq-section       { padding: 60px 0 60px 0; }
    .atrs-faq-grid          { flex-direction: column; gap: 24px; }
    .atrs-faq-title         { flex: none; font-size: 22px; }
    .atrs-faq-list          { gap: 16px; }
    .atrs-faq-question      { padding: 20px 34px 16px 30px; }
    .atrs-faq-answer        { padding: 0 44px 24px 30px; }
    .atrs-faq-q-text-open   { font-size: 14px; }
    .atrs-faq-q-text-closed { font-size: 14px; }
  }

  /* ══════════════════════════════════════════
     RESPONSIVE — MOBILE 480px
  ══════════════════════════════════════════ */
  @media (max-width: 480px) {
    .atrs-breadcrumb        { padding: 30px 0 0 0; }
    .atrs-breadcrumb-inner  { padding: 0 16px; gap: 14px; }
    .atrs-bc-item           { font-size: 14px; }
    .atrs-bc-sep            { width: 18px; height: 18px; margin: 0 4px; }
    .atrs-inner             { padding: 0 16px; }
    .atrs-divider           { padding: 0 16px; }
    .atrs-divider hr { margin-top:30px;}
    .atrs-divider1           { padding: 0 16px; }
    .atrs-divider1 hr { margin-top:30px;}

    .atrs-intro             { padding: 30px 0 30px 0; }
    .atrs-intro-title       { font-size: 20px; }
    .atrs-para              { font-size: 14px; }

    .atrs-adv-section       { padding: 30px 0 30px 0; }
    .atrs-section-red-title { font-size: 20px; text-align: left; margin-top:30px; }
    .atrs-sub-heading       { font-size: 20px; margin-bottom: 30px;   padding-top:30px;}
    .atrs-icon-row          { flex-direction: column; align-items: flex-start; gap: 30px; margin-bottom: 30px; }
    .atrs-icon-card         { flex: none; width: 100%; text-align: left; align-items: flex-start; }
    .atrs-icon-text         { font-size: 16px; }

    .atrs-app-section       { padding: 0 0 30px 0; }
    .atrs-contact-para      { font-size: 14px; margin-top: 30px; text-align: left; }
     .atrs-cards-grid        { flex-direction: row;gap: 30px;max-width:100%;   grid-template-columns: repeat(1, 1fr);  }
    .atrs-cards-section     { padding: 30px 0 60px 0; }
    .atrs-card-img          { height: 300px; }
    .atrs-card-body         { padding: 20px 20px 20px 20px; }
    .atrs-card-title        { font-size: 20px; }
    .atrs-card-desc         { font-size: 14px; }
    .atrs-card-link         { font-size: 14px; }

    .atrs-faq-section       { padding: 0px 0 60px 0; }
    .atrs-faq-grid          { gap: 30px; }
    .atrs-faq-title         { font-size: 20px; }
    .atrs-faq-question      { padding: 24px 16px 20px 16px; }
    .atrs-faq-answer        { padding: 0 16px 16px 16px; font-size: 14px; }
  }
`;

/* Chevron SVGs */
const ChevronUp = () => (
  <svg width="20" height="20" viewBox="0 0 20 20" fill="none">
    <path d="M5 12.5L10 7.5L15 12.5" stroke="#202020" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round"/>
  </svg>
);
const ChevronDown = () => (
  <svg width="20" height="20" viewBox="0 0 20 20" fill="none">
    <path d="M5 7.5L10 12.5L15 7.5" stroke="#202020" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round"/>
  </svg>
);

/* Arrow right icon for card link */
const ArrowRight = () => (
  <svg viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M3.75 9H14.25M9.75 4.5L14.25 9L9.75 13.5" stroke="#EB2019" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
  </svg>
);

/* ── Smooth FAQ accordion item ── */
const FaqItem = ({ q, a, isOpen, onToggle }) => {
  const bodyRef = useRef(null);

  useEffect(() => {
    const el = bodyRef.current;
    if (!el) return;
    if (isOpen) {
      el.style.maxHeight = el.scrollHeight + "px";
    } else {
      el.style.maxHeight = el.scrollHeight + "px";
      el.getBoundingClientRect();
      el.style.maxHeight = "0px";
    }
  }, [isOpen]);

  return (
    <div className={`atrs-faq-item ${isOpen ? "atrs-faq-item-open" : "atrs-faq-item-closed"}`}>
      <button className="atrs-faq-question" onClick={onToggle}>
        <span className={isOpen ? "atrs-faq-q-text-open" : "atrs-faq-q-text-closed"}>{q}</span>
        <span className="atrs-faq-chevron">{isOpen ? <ChevronUp /> : <ChevronDown />}</span>
      </button>
      <div
        ref={bodyRef}
        className={`atrs-faq-body${isOpen ? " atrs-faq-body-open" : ""}`}
      >
        <p className="atrs-faq-answer">{a}</p>
      </div>
    </div>
  );
};

export default function AdorTRSet() {
  const [openIndex, setOpenIndex] = useState(0);
  const handleToggle = (i) => {
    setOpenIndex(prev => (prev === i ? null : i));
  };

  return (
    <div className="atrs-wrap">
      <style>{CSS}</style>

      {/* ══ 1. BREADCRUMB ══ */}
      <nav className="atrs-breadcrumb" aria-label="Breadcrumb">
        <div className="atrs-breadcrumb-inner">
          <a href="/" className="atrs-bc-item">Home</a>
          <span className="atrs-bc-sep"><img src={BcSepIcon} alt="" /></span>
          <a href="#" className="atrs-bc-item">Business</a>
          <span className="atrs-bc-sep"><img src={BcSepIcon} alt="" /></span>
          <a href="/products" className="atrs-bc-item">Clean Air</a>
          <span className="atrs-bc-sep"><img src={BcSepIcon} alt="" /></span>
          <span className="atrs-bc-item atrs-active">Ador TR Set</span>
        </div>
      </nav>

      {/* ══ DIVIDER ══ */}
      <div className="atrs-divider1" ><hr /></div>

      {/* ══ 2. INTRO ══ */}
      <section className="atrs-intro">
        <div className="atrs-inner">
          <h1 className="atrs-intro-title">Ador TR Set</h1>
          <p className="atrs-para">
            Ador TR Sets are available in both 1-phase, 3-phase and 400 Hz configurations, each offering unique performance benefits for dust separation. Whether your Electrostatic Precipitator (ESP) requires high-voltage precision or enhanced efficiency under heavy loads, we deliver tailor-made solutions designed to meet your specific requirements. With hermetically sealed construction and IP-65-rated protection, they ensure reliable performance in demanding environments. The lid-mounted assembly makes maintenance easy, while high-quality components guarantee smooth, stable power output for efficient dust collection.
          </p>
          <p className="atrs-para">
            With advanced microprocessor controls, ripple-free DC output, and energy-efficient performance, our Ador TR sets maximize particulate collection while minimizing energy costs. Trusted across industries like cement, steel, power, chemicals, and paper, Ador's custom-engineered solutions help businesses meet environmental compliance standards with ease.
          </p>
        </div>
      </section>

      {/* ══ DIVIDER ══ */}
      <div className="atrs-divider"><hr /></div>

      {/* ══ 3. ADVANTAGES ══ */}
      <section className="atrs-adv-section">
        <div className="atrs-inner">
          <h2 className="atrs-section-red-title">Ador TR Set: Advantages &amp; Applications</h2>
          <h3 className="atrs-sub-heading">Advantages</h3>

          {/* Row 1 — 3 cards */}
          <div className="atrs-icon-row">
            {ADVANTAGES.slice(0, 3).map((item, i) => (
              <div key={i} className="atrs-icon-card">
                <div className="atrs-icon-circle">
                  <img src={item.icon} alt="" />
                </div>
                <p className="atrs-icon-text">{item.text}</p>
              </div>
            ))}
          </div>

          {/* Row 2 — 2 cards centered */}
          <div className="atrs-icon-row">
            {ADVANTAGES.slice(3, 5).map((item, i) => (
              <div key={i} className="atrs-icon-card">
                <div className="atrs-icon-circle">
                  <img src={item.icon} alt="" />
                </div>
                <p className="atrs-icon-text">{item.text}</p>
              </div>
            ))}
          </div>

        </div>
      </section>

      {/* ══ DIVIDER ══ */}
      <div className="atrs-divider"><hr /></div>

      {/* ══ 4. END APPLICATIONS ══ */}
      <section className="atrs-app-section">
        <div className="atrs-inner">
          <h3 className="atrs-sub-heading">End Applications</h3>

          {/* 2 cards centered */}
          <div className="atrs-icon-row">
            {END_APPLICATIONS.map((item, i) => (
              <div key={i} className="atrs-icon-card">
                <div className="atrs-icon-circle">
                  <img src={item.icon} alt="" />
                </div>
                <p className="atrs-icon-text">{item.text}</p>
              </div>
            ))}
          </div>

          <p className="atrs-contact-para">
            <a href="/contact">Contact us</a> today to discover how Ador TR Sets can power your path toward cleaner air and greener operations!
          </p>
        </div>
      </section>

      {/* ══ DIVIDER ══ */}
      <div className="atrs-divider"><hr /></div>

      {/* ══ 5. PRODUCT CARDS ══ */}
      <section className="atrs-cards-section">
        <div className="atrs-inner">
          <div className="atrs-cards-grid">
            {PRODUCT_CARDS.map((card, i) => (
              <div key={i} className="atrs-card">
                <img className="atrs-card-img" src={card.img} alt={card.title} />
                <div className="atrs-card-body">
                  <h3 className="atrs-card-title">{card.title}</h3>
                  <p className="atrs-card-desc">{card.desc}</p>
                  <a href={card.link} className="atrs-card-link">
                    Learn More <ArrowRight />
                  </a>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* ══ 6. FAQ ══ */}
      <section className="atrs-faq-section">
        <div className="atrs-inner">
          <div className="atrs-faq-grid">

            {/* Left — title */}
            <h2 className="atrs-faq-title">Frequently Asked Questions (FAQs)</h2>

            {/* Right — accordion */}
            <div className="atrs-faq-list">
              {FAQS.map((faq, i) => (
                <FaqItem
                  key={i}
                  q={faq.q}
                  a={faq.a}
                  isOpen={openIndex === i}
                  onToggle={() => handleToggle(i)}
                />
              ))}
            </div>

          </div>
        </div>
      </section>

    </div>
  );
}